import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { TransHtml, useLocale } from '../i18n/LocaleContext';
import { StoreBadges } from './StoreBadges';
import { SEO } from '../seo/useSeo';
import appIcon from '../assets/landing/app-icon.png';

export const CtaBand = (): React.JSX.Element => {
  const { t } = useLocale();
  // QR points to /get, which auto-redirects to the right store per platform.
  const qrUrl = `${SEO.SITE_URL}/get`;

  return (
    <section id="download" style={{ padding: '40px 0' }}>
      <div className="cta-band">
        <div>
          <span className="eyebrow" style={{ color: 'rgba(255,255,255,.85)' }}>
            {t('cta.eyebrow')}
          </span>
          <TransHtml tag="h2" tKey="cta.h" style={{ marginTop: 12 }} />
          <p>{t('cta.p')}</p>
          <StoreBadges height={56} />
        </div>
        <div className="cta-qr">
          <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
            <div className="qr-code">
              <QRCodeSVG
                value={qrUrl}
                size={232}
                bgColor="transparent"
                fgColor="#ffffff"
                level="H"
                marginSize={0}
                imageSettings={{
                  src: appIcon,
                  height: 50,
                  width: 50,
                  excavate: true,
                }}
              />
            </div>
            <div className="qr-label">{t('cta.qr')}</div>
          </div>
        </div>
      </div>
    </section>
  );
};
